// @ts-nocheck
(function () {
  function init(video) {
    if (video.dataset.homeIdleVideoInit) return;
    video.dataset.homeIdleVideoInit = 'true';
    video.muted = true;
    video.defaultMuted = true;

    if (typeof IntersectionObserver === 'undefined') return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(function () {});
            }
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.35, rootMargin: '0px' },
    );

    observer.observe(video);
  }

  function scan(scope) {
    (scope || document).querySelectorAll('[data-home-idle-video]').forEach(function (el) {
      if (el instanceof HTMLVideoElement) init(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target);
  });
})();
